import Header from './components/Header';
import Banner from './components/Banner';
import Gallery from './components/Gallery';
import Footer from './components/Footer';

function App() {
  let app = 'Flixster';
  let title = 'Explore Your Cinematic Journey!';
  let text = 
    'From heart-pounding thrillers to heartwarming dramas, discover a curated selection of films tailored to your tastes.'
  ;

  const links = [
    {
      index: 0,
      name: 'Categories',
      url: 'https://www.coponents.com/categories/'
    },
    {
      index: 1,
      name: 'Favourites',
      url: 'https://www.coponents.com/favorites/'
    },
    {
      index: 2,
      name: 'Releases',
      url: 'https://www.coponents.com/releases/'
    },
    {
      index: 3,
      name: 'My List',
      url: 'https://www.coponents.com/my-list/'
    },
    {
      index: 4,
      name: 'Settings',
      url: 'https://www.coponents.com/settings/'
    }
  ];

  const movies = [
    {
      id: 1001,
      title: 'Jurassic Park',
      poster: 'https://raw.githubusercontent.com/mrspecht/media/main/img/jurassic-park.jpg'
    },
    {
      id: 1002,
      title: 'The Lion King',
      poster: 'https://raw.githubusercontent.com/mrspecht/media/main/img/the-lion-king.jpg'
    },
    {
      id: 1003,
      title: 'Avengers: Infinity War',
      poster: 'https://raw.githubusercontent.com/mrspecht/media/main/img/avengers-infinity-war.jpg'
    },
    {
      id: 1004,
      title: 'The Shining',
      poster: 'https://raw.githubusercontent.com/mrspecht/media/main/img/the-shining.jpg'
    }
  ];

  const footerOptions = [
    {
      index: 0,
      name: 'Contact',
      url: 'https://www.coponents.com/contact/'
    },
    {
      index: 1,
      name: 'Privacy Policy',
      url: 'https://www.coponents.com/privacy/'
    },
    {
      index: 2,
      name: 'Terms & Conditions',
      url: 'https://www.coponents.com/terms/'
    },
    {
      index: 3,
      name: 'Our Community',
      url: 'https://www.coponents.com/community/'
    },
    {
      index: 4,
      name: 'Support',
      url: 'https://www.coponents.com/support/'
    }
  ];

  return (
    <>
      <Header app={app} list={links} />
      <main>
        <Banner title={title} text={text}/>
        <div className='container'>
          <Gallery list={movies} />
        </div>
      </main>
      <Footer list={footerOptions} />
    </>
    
  );
}

export default App;
